module.exports = __webpack_public_path__ + "static/media/flower4.52b3ca71.png";